
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.805 1.484L.5 1.04C1.052.591 1.555.367 2.008.367c.453 0 .778.159.976.477.198.312.297.825.297 1.539v2.383c0 1.687.594 2.53 1.781 2.53.615 0 1.1-.244 1.454-.734.354-.494.53-1.19.53-2.085 0-1.667-.325-2.85-.976-3.547V.516h1.5c.438.937.657 2.073.657 3.406 0 1.213-.32 2.219-.961 3.015-.641.792-1.487 1.188-2.54 1.188-.984 0-1.697-.273-2.14-.82-.443-.547-.664-1.378-.664-2.492V2.578c0-.62-.031-1.002-.094-1.148a.337.337 0 00-.336-.227c-.15 0-.38.094-.687.281z","fill":"currentColor"}})])
          )
        }
      }
    